module.exports = __webpack_public_path__ + "img/TOYOTA.a5f7cc85.webp";